import Info from '@mui/icons-material/Info';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { abbreviatedNumber } from '@openx/utils/lib/abbreviatedNumber.ts';
import { MINIMUM_ESTIMATED_REACH } from '@openx/utils/services/config.ts';
import { useTranslation } from 'react-i18next';

export const ReachInfoTooltip = () => {
  const { t } = useTranslation();

  return (
    <Tooltip
      placement="top"
      title={
        <Typography
          sx={{
            fontSize: 12,
            lineHeight: 1.325,
            maxWidth: 138,
          }}
        >
          {t('Lookalike seed size must be greater than {minSeedSize} unique users.', {
            minSeedSize: abbreviatedNumber(MINIMUM_ESTIMATED_REACH),
          })}
        </Typography>
      }
    >
      <IconButton>
        <Info
          fontSize="small"
          data-test="reach-info-icon"
          sx={{
            color: 'textSecondary',
          }}
        />
      </IconButton>
    </Tooltip>
  );
};
